import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const NameForm = ({ id, Title, path, onSubmit }) => {
    const { t } = useTranslation('common');
    const [title, setTitle] = useState(Title || "");
    const [errorList, setErrorList] = useState([]);
    const toastIdRef = useRef(null);

    useEffect(() => {
        setTitle(Title || "");
    }, [Title]);

    const handleSubmit = (e) => {
        e.preventDefault();

        toastIdRef.current = toast(t('Processing'), {
            position: "bottom-left",
            autoClose: false
        });
        
        toast.update(toastIdRef.current, {
            render: () => <div> <i className="fa-spin fas fa-spinner "></i> {t('Processing')} </div>,
            autoClose: false,
            closeOnClick: false,
        });

        const trimmedTitle = title.trim();
        if (!trimmedTitle) {
            setErrorList([<li key="error-title">{t('Pages.FileManager.Form.Title.error')}.</li>]);

            toast.update(toastIdRef.current, {
                render: () => (
                    <div>
                        <div className="h5">
                            <i className="icon fal fa-bug"></i>
                            {t('Pages.Register.error_AllInformationIsRequired_toast.Title')}
                        </div>
                        <div className="h6">
                            {t('Pages.Register.error_AllInformationIsRequired_toast.Body')}
                        </div>
                    </div>
                ),
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            const formData = new FormData();
            formData.append("Title", trimmedTitle);
            if (id) {
                formData.append("filename", id);
            }

            setErrorList([]);
            onSubmit(formData, toastIdRef.current);
        }
    };

    return (
        <form method="POST" encType="multipart/form-data" className="contact-form" onSubmit={handleSubmit} autoComplete="new-password">
            {errorList.length > 0 && (
                <div className="alert alert-danger mb-4 p-3 w-100" role="alert">
                    <h5 className="alert-heading">{t('ErrorsList')}</h5>
                    <div className="border-bottom border-white opacity-20 mb-2"></div>
                    <ul className="list-unstyled mb-0">
                        {errorList}
                    </ul>
                </div>
            )}

            <div className="form-group w-100">
                <label className='text-dark font-size-h5 mb-2'>
                    {t('Pages.FileManager.Form.Title.title')}{' '}
                    <i title={t('required')} className="fas fa-star-of-life font-size-10 text-danger"></i>
                </label>
                <input
                    name="Title"
                    type="text"
                    required={true}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder={t('Pages.FileManager.Form.Title.Placeholder')}
                    title={t('Pages.FileManager.Form.Title.title')}
                    className="form-control"
                    autoComplete="off"
                    spellCheck={false}
                />
            </div>

            <div className="form-group w-100 mt-3">
                <button type="submit" className="custom-button w-100">
                    <span><i className="fal fa-save"></i> {t('Pages.FileManager.Form.submit')}</span>
                </button>
            </div>
        </form>
    );
};

export default NameForm;
